import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useTexts } from "Components/TextContext";
import { Button, Ingress } from "Components/TextContext/commonComponentEnums";
import { removeWhitespace } from "Formatting/index";
import { ReduxState } from "Store/rootReducer";
import { userIdentificationStart } from "Store/userIdentification";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoginForm } from "../LoginForm";
import { useBankIdLoginHandler } from "../bankIdLoginHooks";
import { NoLoginFormValues } from "../loginFormValues";
import { StyledIngress, StyledInlineButton } from "../styled";
import {
  CHANGE_YOUR_MIND_AND_LOGIN_WITH_BANK_ID_AFTER_ALL_BUTTON_TRACK_ID,
  NO_BANK_ID_LOGIN_BUTTON_TRACK_ID,
} from "./alternativeProductLoginConstants";

interface Props {
  productBackendName: ProductBackendName;
}

export const AlternativeNoBankIdLogin = ({
  productBackendName,
}: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const { getText } = useTexts();
  const ingressText = `${getText(Ingress.LOGIN_WITHOUT_BANKID)} `;
  const { userIdentification } = useSelector((state: ReduxState) => state);
  const validNameNin = userIdentification.current?.newCustomerResponse?.isValid;
  const handleBankIdLogin = useBankIdLoginHandler();
  const handleNoLogin = (formValues: NoLoginFormValues): void => {
    dispatch(
      userIdentificationStart({
        ssn: removeWhitespace(formValues.nin),
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        products: productBackendName,
      }),
    );
  };
  return (
    <>
      <StyledIngress>
        {ingressText}
        <StyledInlineButton
          onClick={() => handleBankIdLogin()}
          data-trackid={
            CHANGE_YOUR_MIND_AND_LOGIN_WITH_BANK_ID_AFTER_ALL_BUTTON_TRACK_ID
          }
          aria-label={getText(Button.IDENTIFY_WITH_BANK_ID)}
        >
          {`${getText(Button.BANK_ID)}.`}
        </StyledInlineButton>
      </StyledIngress>
      <LoginForm
        onSubmit={handleNoLogin}
        isLoading={userIdentification.isLoading}
        validNameNin={validNameNin}
        submitButtonTrackId={NO_BANK_ID_LOGIN_BUTTON_TRACK_ID}
      />
    </>
  );
};
